import AsyncStorage from '@react-native-async-storage/async-storage';
import { API } from '../../service/api';
import { StudentActions } from '../reducers/studentReducer';

export const login = (userData, navigation) => (dispatch) => {
  dispatch({ type: StudentActions.TOGGLE_LOADER });
  API.post('/auth', {
    email: userData.email,
    senha: userData.pass,
    perfil: 'ALUNO',
  }).then(({ data }) => {
    if (data.success) {
      AsyncStorage.setItem('PROFILE', 'ALUNO');
      AsyncStorage.setItem('ID', data.data[0].id_usuario);
      dispatch({ type: StudentActions.UPDATE_DATA, dataType: 'studentData', dataValue: data.data[0] });
      dispatch({ type: StudentActions.UPDATE_DATA, dataType: 'isError', dataValue: false });

      // navigation.navigate('Student Profile');
      navigation.navigate('Student', { screen: 'Student Profile' });
    }
  }).catch(() => {
    dispatch({ type: StudentActions.TOGGLE_ERROR });
  }).finally(() => {
    dispatch({ type: StudentActions.TOGGLE_LOADER });
  });
};
